import {jQuery as $, lodash as _} from 'lib/shim';



/*
	Needs this css to work.
	Should only be used in really problematic cases such as form inputs in fixed layers
	in iOS Safari < 11.3.

	body.scroll-locked {
		overflow: hidden;

		position: fixed;
		left: 0;

		width: 100%;
		height: 100%;
	}
*/



export function lockScroll(){
	$('body')
		.data('scroll-lock-scroll-top', $(window).scrollTop())
		.addClass('scroll-locked')
		.css('top', $(window).scrollTop())
	;
}



export function unlockScroll(){
	let $body = $('body');

	$body
		.removeClass('scroll-locked')
		.css('top', '')
	;

	if( $body.data('scroll-lock-scroll-top') ){
		window.scrollTo(0, parseInt($body.data('scroll-lock-scroll-top'), 10));
		$body.removeData('scroll-lock-scroll-top');
	}
}
